import $ from 'jquery';

export default function menu() {
    //SCRIPT MENU

    const menu = document.getElementById('menu');
    if (!menu) {
        return;
    }

    const hamburguesa = document.getElementById('hamburguesa');
    if (hamburguesa) {
        hamburguesa.addEventListener('click', function (ev) {
            menu.classList.toggle('opened');
            document.body.classList.toggle('no-scroll');
        });
    }

    const close = document.querySelector('.js-close-menu');
    if (close) {
        close.addEventListener('click', function (ev) {
            menu.classList.toggle('opened');
            document.body.classList.remove('no-scroll');
        });
    }

    const keep = document.querySelector('.js-keep-menu');
    if (keep) {
        keep.addEventListener('click', function (ev) {
            ev.stopPropagation();
        });
    }

    const close2 = document.querySelector('.js-close2-menu');
    if (close2) {
        close2.addEventListener('click', function (ev) {
            menu.classList.toggle('opened');
            document.body.classList.remove('no-scroll');
        });
    }

    const hamburguesa2 = document.getElementById('hamburguesa2');
    if (hamburguesa2) {
        hamburguesa2.addEventListener('click', function (ev) {
            menu.classList.toggle('opened');
            document.body.classList.toggle('no-scroll');
        });
    }

    //END SCRIPT MENU

    //SCRIPT SUBMENU

    $('.js_nested_menu_option').each((idx, elem) => {
        var block = $(elem);
        block.find('.menu_btn').on('click', (e) => {
            e.preventDefault();
            var button = $(e.currentTarget);
            button.toggleClass('hover');
            button.find('svg').toggleClass('rotate180');
            block.find('.menu_btn_submenu').toggleClass('none');
        });
    });

    // END SCRIPT SUBMENU
}
